import React from 'react';
import { Link } from 'react-router-dom';
import { Menu, LogOut, Shield } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '../AuthProvider';
import ThemeToggle from '../theme/ThemeToggle';

/**
 * Floating glass top bar (concept layout): page title on the left; theme, admin and sign-out on the
 * right. The profile and plan usage live in the sidebar footer.
 */
export default function Header({ title, onMenuClick, actions }) {
  const { user, logout } = useAuth();

  return (
    <header className="app-chrome sticky top-0 z-30 flex h-14 items-center justify-between gap-3 border-b px-3 sm:px-4 md:h-[60px] md:px-5">
      <div className="flex min-w-0 items-center gap-2">
        <Button
          variant="ghost"
          size="icon"
          className="h-9 w-9 shrink-0 md:hidden"
          onClick={onMenuClick}
          aria-label="Open navigation menu"
        >
          <Menu className="h-5 w-5" />
        </Button>
        <h2 className="truncate text-base font-semibold tracking-tight text-foreground md:text-[17px]">{title}</h2>
      </div>

      <div className="flex shrink-0 items-center gap-1.5 sm:gap-2">
        {actions}
        <ThemeToggle compact />
        {user?.is_admin && (
          <Button asChild variant="ghost" size="icon" className="h-9 w-9 text-muted-foreground hover:text-foreground">
            <Link to="/admin" title="Admin" aria-label="Admin">
              <Shield className="h-4 w-4" />
            </Link>
          </Button>
        )}
        {!user?.is_guest && (
          <Button
            variant="ghost"
            size="icon"
            onClick={() => { logout(); window.location.href = '/login'; }}
            className="h-9 w-9 text-muted-foreground hover:text-destructive"
            title="Sign out"
            aria-label="Sign out"
          >
            <LogOut className="h-4 w-4" />
          </Button>
        )}
      </div>
    </header>
  );
}
